import { render, staticRenderFns } from "./PregledZaposlenog.vue?vue&type=template&id=23d12668&scoped=true&"
import script from "./PregledZaposlenog.vue?vue&type=script&lang=ts&"
export * from "./PregledZaposlenog.vue?vue&type=script&lang=ts&"
import style0 from "./PregledZaposlenog.vue?vue&type=style&index=0&id=23d12668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d12668",
  null
  
)

export default component.exports